import { useState } from 'react';

import { ModalWindow } from '../../../Components/ModalWindow';
import { GoodModal } from '../../MainPage/GoodsList/GoodModal/GoodModal';

export const Slide = ({ data: { name, img, house, price, description, id } }) => {
  const [isModalOpened, setOpenModal] = useState(false);

  return (
    <>
      <div className="flex gap-4 mobile:gap-10 md:gap-20 items-center justify-center">
        <img className="block w-32 h-32 smart:w-48 smart:h-48 xl:w-72 xl:h-72" src={img} alt="poster" />
        <div className="flex flex-col items-center">
          <h2 className="my-2 font-crimson font-bold md:w-80 xl:w-full text-font text-sm mobile:text-base smart:text-xl md:text-2xl leading-6 flex tracking-wider text-center">
            {name}
          </h2>
          <hr className="my-2 h-01 w-32 mobile:w-40 smart:w-48 md:w-78 border-none bg-gradient-to-r from-grStart to-grEnd mb-4" />
          <button
            className="p-1 rounded-xl border-transparent h-10 w-28 flex justify-center items-center bg-gradient-to-r from-grStart to-grEnd font-poppins leading-5 border text-font hover:bg-none hover:border-borderColor hover:bg-font hover:text-borderColor duration-300"
            onClick={() => {
              setOpenModal(true);
            }}>
            View More
          </button>
        </div>
      </div>
      {isModalOpened && (
        <ModalWindow isOpen={isModalOpened} closeModal={() => setOpenModal(false)}>
          <GoodModal
            name={name}
            img={img}
            house={house}
            price={price}
            description={description}
            id={id}
            onClose={() => setOpenModal(false)}
          />
        </ModalWindow>
      )}
    </>
  );
};
